import axios from "axios";
import Vue from "vue";

window.Vue = Vue;

window.addEventListener("DOMContentLoaded", function () {
    new Vue({
        el: "#contact",
        data: function () {
            return {
                name:'',
                email:'',
                phone:'',
                message:'',
                prefix:"40",
                errorMessage_phone:'',
                errorMessage_name:'',
                errorMessage_email:'',
                errorMessage_message:'',
                errorMessage_city:'',
                loading:false,
                responseText:false,
                errorMessage_checkbox_agree_condition:"",
                checkbox_agreement:"",
                area:null,
                area_zone:null,
            };
        },
        methods: {
            chooseDropdownValue(event) {
                let target = event.target;
                let options = target.options;
                let selectedIndex = options.selectedIndex;
                let selectedOption = options[selectedIndex] || null;
                this.area_zone = selectedOption
                    ? selectedOption.getAttribute("data-zone")
                    : null;
                this.area = selectedOption.value;    
                this.area_city = selectedOption.text;    
                },
            sendEmail(language){
                const vm = this;
                var phoneNumber =  vm.formatRomaniaPhoneNumber(vm.phone);
                var checkValid = true;
                var email=vm.validateEmail(vm.email);
                if (!vm.checkbox_agreement) {
                    vm.errorMessage_checkbox_agree_condition = "can't be empty";
                    checkValid =false;
                } else {
                    vm.errorMessage_checkbox_agree_condition = "";
                }
                if(vm.email !=null && vm.email !='' && !email ){
                    checkValid =false;
                    vm.errorMessage_email = "Not valid";
                }
                else{
                    vm.errorMessage_email = "";
                }
                if (vm.phone == null || vm.phone == "" ) {
                    vm.errorMessage_phone = "Can't be empty";
                    checkValid =false;
                } else if (vm.phone!=null && this.phone!='' && !vm.validatePhoneNumber(phoneNumber)) {
                    checkValid = false;
                    vm.errorMessage_phone = "Not valid";
                } else {
                    vm.errorMessage_phone = "";
                }
                if(language == 'ro'){
                    if (vm.area_city == null || vm.area_city == "" ) {
                        vm.errorMessage_city = "Can't be empty";
                        checkValid =false;
                    }  else {
                        vm.errorMessage_city = "";
                    }
                }
                if(checkValid)
                {
                    vm.loading = true;
                    vm.responseText = false;
                    console.log(vm.area_city);
                     axios
                    .post("/api/sendEmailAndMessage",{name:vm.name,email:vm.email,phone:phoneNumber,message:vm.message,language:language,city:vm.area_city})
                    .then((response) => {
                        vm.responseText = true;
                    })
                    .catch((error)=>{
                        vm.responseText =false;
                    })
                    .then(()=>{
                        vm.loading=false;
                    });
                }   
                },

             validatePhoneNumber(str) {
                var phoneNumber = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,8}$/im.test(str);
                return phoneNumber;
              },

              formatRomaniaPhoneNumber(str) {
                let phoneNumber = str.replace(/\D/g, '');
                if(phoneNumber.length==10 && phoneNumber[0]==0){
                    phoneNumber = "4"+phoneNumber;
                }
                if(phoneNumber.length==9 && phoneNumber[0]==7){
                    phoneNumber = "40"+phoneNumber;
                }
                return phoneNumber;
              },
              
              validateEmail(str){
                var email = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(str);
                return email;
              }
              
        },
    });
});
